export default function EthnicityInput(props) {
    return (
        <>
            <label htmlFor="ethnicity-input"><strong>Ethnicity</strong></label>
            <select id="ethnicity-input" name="ethnicity" className="form-control" {...props}>
                <option value="" className="placeholder-option">Select Ethnicity</option>
                <option value="Asian">Asian</option>
                <option value="Black">Black/African-American</option>
                <option value="Hispanic/Latino">Hispanic/Latino (of any race)</option>
                <option value="American Indian/Alaska Native">American Indian/Alaska Native</option>
                <option value="Native Hawaiian/Pacific Islander">Native Hawaiian/Pacific Islander</option>
                <option value="White">White</option>
                <option value="Two or more races">Two or more races</option>
                <option value="Unknown">Unknown</option>
                <option value="N/A">Prefer not to answer</option>
            </select>
        </>
    );
}